import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDateString(
  dateString: string,
  timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone
) {
  const date = new Date(dateString)
  return date.toLocaleString('en-US', {
    timeZone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
}

/**
 * Formats a role string into a human-readable display name.
 * Converts 'org:client_admin' to 'Client Admin', 'org:learner' to 'Learner', etc.
 */
export function formatRoleName(role: string | undefined): string | undefined {
  if (!role) return undefined

  // Remove 'org:' prefix if present
  const roleWithoutPrefix = role.replace(/^org:/, '')

  // Split by underscore and capitalize each word
  return roleWithoutPrefix
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
